import Widget from "components/widget/Widget";
import AnalyticsTable from "features/main-dashboard/components/AnalyticsTable";
import DailyTraffic from "features/main-dashboard/components/DailyTraffic";
import TotalSpent from "features/main-dashboard/components/TotalSpent";
import WeeklyRevenue from "features/main-dashboard/components/WeeklyRevenue";
import useDashboard from "hooks/useDashboard";
import { IoMdHome } from "react-icons/io";
import { MdBarChart, MdDashboard } from "react-icons/md";

const Dashboard = () => {
  const { totalProduct, totalSales, totalUsers, totalNewUsers, analyticsData } =
    useDashboard();

  const transformedData = (analyticsData || []).map((item) => {
    const dimensionValues = item.dimensionValues;
    const metricValues = item.metricValues;

    return {
      date: dimensionValues[0]?.value || "N/A",
      country: dimensionValues[2]?.value || "N/A",
      city: dimensionValues[1]?.value || "N/A",
      device: dimensionValues[3]?.value || "N/A",
      activeUsers: metricValues[0]?.value || "0",
      pageViews: metricValues[2]?.value || "0",
    };
  });

  const uniqueCountries = [
    ...new Set(
      (analyticsData || []).map((item) => item.dimensionValues[2]?.value)
    ),
  ];
  const totalCountries = uniqueCountries.length;

  return (
    <div>
      <div className="mt-3 grid grid-cols-1 gap-5 md:grid-cols-2 lg:grid-cols-3 2xl:grid-cols-3 3xl:grid-cols-6">
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Sales This Month"}
          subtitle={`$${totalSales}`}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"Total Products"}
          subtitle={totalProduct}
        />
        <Widget
          icon={<MdDashboard className="h-6 w-6" />}
          title={"Total Users"}
          subtitle={totalUsers}
        />
        <Widget
          icon={<MdBarChart className="h-7 w-7" />}
          title={"New User"}
          subtitle={totalNewUsers}
        />
        <Widget
          icon={<IoMdHome className="h-6 w-6" />}
          title={"Total Country"}
          subtitle={totalCountries}
        />
      </div>

      <div className="mt-5 grid grid-cols-1 gap-5 md:grid-cols-2">
        <TotalSpent />
        <WeeklyRevenue />
        {/* <PieChartCard /> */}
      </div>

      <div className="mt-5 flex  items-start justify-between gap-5">
        <div className="w-2/6 rounded-[20px] md:grid-cols-2">
          {analyticsData && <DailyTraffic analyticsData={analyticsData} />}
        </div>
        <div className="w-4/6">
          <AnalyticsTable tableData={transformedData} />
        </div>
      </div>
    </div>
  );
};

export default Dashboard;
